<template>
  <v-card>
    <v-card-title>
      Súbory ({{ count }})

      <v-spacer/>

      <UploadImage
          :icon="true"
          @init="init"
      />

      &nbsp;

      <UploadPdf
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content/>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        <a
                            @click="setOrder($store.state.register.File.Filter.order['createdAt'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.File.Filter.order['createdAt'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.File.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Dátum a čas nahratia
                        </a>
                      </th>

                      <th
                          class="fixed"
                      >
                        Odkaz
                      </th>

                      <th>
                        Náhľad
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="files.length > 0"
                    >
                      <tr
                          v-for="File in files"
                          :key="File.id"
                      >
                        <td>
                          {{ new Date(File.createdAt)|dateFormat('DD.MM.YYYY HH:mm') }}
                        </td>

                        <td>
                          <a
                              v-if="File.dir === 'upload/img'"
                              @click="downloadFileByLink(loadLinkByPath('files/generate/image/original/' + File.token))"
                          >
                            {{ loadLinkByPath('files/generate/image/original/' + File.token) }}
                          </a>

                          <a
                              v-if="File.dir === 'upload/pdf'"
                              @click="downloadFileByLink(loadLinkByPath('files/generate/pdf/' + File.token))"
                          >
                            {{ loadLinkByPath('files/generate/pdf/' + File.token) }}
                          </a>
                        </td>

                        <td>
                          <v-img
                              v-if="File.dir === 'upload/img'"
                              :src="loadLinkByPath('files/generate/image/original/' + File.token)"
                              alt="Obrázok"
                              max-width="36px"
                          />

                          <template
                              v-if="File.dir === 'upload/pdf'"
                          >
                            -
                          </template>
                        </td>

                        <td
                            class="text-right fixed"
                        >

                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="4"
                            class="text-center"
                        >
                          Nenašli sa žiadne súbory.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getFileFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Files from '@/services/files'

  import UploadImage from '@/components/Files/UploadImage'
  import UploadPdf from '@/components/Files/UploadPdf'

  export default {
    name: 'Files',
    components: {
      UploadImage,
      UploadPdf
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        files: [],
        params: {
          Filters: {},
          order: this.$store.state.register.File.Filter.order['createdAt'].value,
          by: this.$store.state.register.File.Filter.by['DESC'].value,
          limit: this.$store.state.register.File.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Súbory'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.File.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.File.Filter.by['DESC'].value

            break

          case this.$store.state.register.File.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.File.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Súbory',
              to: '/files'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Files
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.files = response.data.data.files

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      },
      downloadFileByLink(link) {
        window.open(link)
      }
    }
  }
</script>
